
import { Component, Prop, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import productOptionMixin from '@/mixin/productOption'
import currencyOptionMixin from '@/mixin/currencyOption'
import {
  getAgentProductList,
  delAgentProduct,
  getMerchantStatistical
} from '@/api/merchant/agentProduct'
import { getDescendants } from '@/api/merchant/descendants'
import editAgentProduct from './editAgentProduct.vue'
import pagination from '@/components/Pagination/index.vue'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { descendantsRules } from '@/utils/rules'
import moment from 'moment'
import { AppModule } from '@/store/modules/app'
import subordinateAgency from './subordinateAgency.vue'
import subProduct from './subFeeInfo.vue'

@Component({
  name: 'agentProductList',
  components: {
    editAgentProduct,
    pagination,
    subordinateAgency,
    subProduct
  }
})
export default class AgentProductList extends mixins(
  productOptionMixin,
  currencyOptionMixin
) {
  @Prop({ required: true }) merchant_no!: string

  get language() {
    return AppModule.language
  }

  private tabName: string = 'Agent Product'
  private agentProductId: string | null = null
  private listLoading: boolean = true
  private dialogVisible: boolean = false
  private agentProductList: any[] = []
  private descendants: any[] = []
  private totalData: any = {}

  queryForm: any = {
    start_time: null,
    end_time: null,
    descendant_merchant_no: null
  }

  private rules = descendantsRules
  private date: any[] = getCurrentDate()
  private pickerOptions = pickerOptions
  private total: number = 0
  private listQuery = {
    page: 1,
    limit: 20
  }
  private productNameList: string[] = []

  // 打开子产品窗口
  private subFeeVisible: boolean = false
  private subInfo: any = {}

  private openSubDialog(row: any) {
    this.subFeeVisible = true
    this.subInfo = row
  }

  private async closeSubFee() {
    this.subFeeVisible = false
    await this.getAgentProductList()
  }

  private submerchantFeeVisible: boolean = false
  private submerchantInfo: any = {}
  private openMerchantSubDialog(row: any) {
    this.submerchantFeeVisible = true
    this.submerchantInfo = row
  }
  private async closeMerchantSubFee() {
    this.submerchantFeeVisible = false
  }

  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size: number) {
    this.pagesize = size
    this.hadleGetFilesListApi()
    this.getMerchantStatistical()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage: number) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
    this.getMerchantStatistical()
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      const data: any = {
        merchant_no: this.merchant_no,
        ...this.queryForm,
        page_size: this.pagesize,
        page: this.currentPage
      }
      await getDescendants(data).then((res: any) => {
        this.descendants = res.results
        this.productNameList = this.descendants
          .map((item: any) => item.product_name)
          .filter((name: any) => name)
        this.total = res.count
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  @Watch('date', { immediate: true })
  private onDateChang() {
    if (this.date && this.date.length >= 2) {
      this.queryForm.start_time = dateToSeconds(this.date[0])
      this.queryForm.end_time = dateToSeconds(this.date[1])
    } else {
      this.date = getCurrentDate()
    }
  }

  private currencyChange() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.date = getCurrentDate()
    this.agentProductList = []
    this.getProductName()
    this.getAgentProductList()
  }

  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
    this.getMerchantStatistical()
  }

  private reset() {
    this.queryForm = {
      currency: this.queryForm.currency,
      start_time: null,
      end_time: null,
      product_code: null,
      descendant_merchant_no: null
    }
    this.date = getCurrentDate()
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
      this.getMerchantStatistical()
    })
  }

  // 打开编辑窗口
  private openDialog(agentProductId: string | null) {
    this.agentProductId = agentProductId
    this.dialogVisible = true
    this.productNameList = this.agentProductList
      .map((item: any) => item.product_name)
      .filter((name: any) => name)
  }

  private back() {
    this.$emit('close')
  }

  private closeDialog() {
    this.getAgentProductList()
  }

  // 代理产品详情
  private async getAgentProductList() {
    const data: any = {
      merchant_no: this.merchant_no
    }
    try {
      this.listLoading = true
      await getAgentProductList(data).then((res: any) => {
        this.agentProductList = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 下级商户 统计
  private async getMerchantStatistical() {
    const data: any = {
      merchant_no: this.merchant_no,
      ...this.queryForm
    }
    try {
      this.listLoading = true
      await getMerchantStatistical(data).then((res: any) => {
        this.totalData = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 介绍商户列表 产品名查询
  private queryProductName: any[] = []
  private async getProductName() {
    const data: any = {
      merchant_no: this.merchant_no,
      currency: this.queryForm.currency
    }
    try {
      this.listLoading = true
      await getAgentProductList(data).then((res: any) => {
        this.queryProductName = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  // 删除商户产品
  private del(id: number) {
    let confirmMessage = ''
    let confirmButtonText = ''
    let cancelButtonText = ''

    switch (this.language) {
      case 'en':
        confirmMessage = 'Are you sure to delete it?'
        confirmButtonText = 'Yes'
        cancelButtonText = 'Cancel'
        break
      case 'zh_cn':
        confirmMessage = '确定要删除吗？'
        confirmButtonText = '是的'
        cancelButtonText = '取消'
        break
      case 'zh_tw':
        confirmMessage = '確定要刪除嗎？'
        confirmButtonText = '是的'
        cancelButtonText = '取消'
        break
      default:
        confirmMessage = 'Are you sure to delete it?'
        confirmButtonText = 'Yes'
        cancelButtonText = 'Cancel'
    }

    this.$confirm(confirmMessage, {
      confirmButtonText,
      cancelButtonText,
      type: 'warning',
      callback: action => {
        const data: any = {
          merchant_no: this.merchant_no,
          id: id
        }
        if (action === 'confirm') {
          delAgentProduct(data)
            .then(() => {
              let successMsg = ''
              switch (this.language) {
                case 'en':
                  successMsg = 'Delete successful!'
                  break
                case 'zh_cn':
                  successMsg = '删除成功！'
                  break
                case 'zh_tw':
                  successMsg = '刪除成功！'
                  break
              }

              this.$message({
                type: 'success',
                message: successMsg
              })
              this.getAgentProductList()
            })
            .catch(() => {
              let errorMsg = ''
              switch (this.language) {
                case 'en':
                  errorMsg = 'Delete failed!'
                  break
                case 'zh_cn':
                  errorMsg = '删除失败！'
                  break
                case 'zh_tw':
                  errorMsg = '刪除失敗！'
                  break
              }

              this.$message({
                type: 'error',
                message: errorMsg
              })
            })
        }
      }
    })
  }

  private async init() {
    await this.getAgentProductList()
    await this.getProductName()
    await this.getMerchantStatistical()
    await this.hadleGetFilesListApi()
  }

  mounted() {
    this.init()
  }
}
